/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseKingDifferenceMediaCf013Fragment} from '@amblique/contentful/app/contentful/fragments/king-difference-media-cf013/base-king-difference-media-cf013.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';

export const FullKingDifferenceMediaCf013Fragment = gql`
  ${BaseKingDifferenceMediaCf013Fragment}
  ${ImageFragment}

  fragment FullKingDifferenceMediaCf013Fragment on KingDifferenceMediaCf013 {
    ...BaseKingDifferenceMediaCf013Fragment

    mainImagesCollection {
      items {
        __typename
        ... on Image {
          ...ImageFragment
        }
      }
    }
    mainImagesCursorCollection {
      items {
        __typename
        ... on Image {
          ...ImageFragment
        }
      }
    }
    thumbnailImagesCollection {
      items {
        __typename
        ... on Image {
          ...ImageFragment
        }
      }
    }
    thumbnailImagesCursorCollection {
      items {
        __typename
        ... on Image {
          ...ImageFragment
        }
      }
    }
  }
`;
